import {getLocalStorageObject, getLocalStorageStr} from '../../utils/index.js'
import {getMe} from '@/api/sys/user'
import {login, logout} from '@/api/sys/login'

const user = {
    state: {
        accessToken: getLocalStorageStr('accessToken'),
        refreshToken: getLocalStorageStr('refreshToken'),
        accessTokenExp: getLocalStorageStr('accessTokenExp'),
        refreshTokenExp: getLocalStorageStr('refreshTokenExp'),
        userInfo: getLocalStorageObject('userInfo'),
        menuTrees: getLocalStorageObject('menuTrees'),
        permissions: getLocalStorageObject('permissions'),
    },
    mutations: {
        SET_ACCESS_TOKEN: (state, accessToken) => {
            state.accessToken = accessToken
            localStorage.setItem('accessToken', accessToken)
        },
        SET_REFRESH_TOKEN: (state, refreshToken) => {
            state.refreshToken = refreshToken
            localStorage.setItem('refreshToken', refreshToken)
        },
        SET_ACCESS_TOKEN_EXP: (state, accessTokenExp) => {
            state.accessTokenExp = accessTokenExp
            localStorage.setItem('accessTokenExp', accessTokenExp)
        },
        SET_REFRESH_TOKEN_EXP: (state, refreshTokenExp) => {
            state.refreshTokenExp = refreshTokenExp
            localStorage.setItem('refreshTokenExp', refreshTokenExp)
        },
        SET_USER_INFO: (state, userInfo) => {
            state.userInfo = userInfo
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
        },
        SET_PERMISSIONS: (state, permissions) => {
            state.permissions = permissions
            localStorage.setItem('permissions', JSON.stringify(permissions))
        },
        SET_MENU_TREE: (state, menuTrees) => {
            state.menuTrees = menuTrees
            localStorage.setItem('menuTrees', JSON.stringify(menuTrees))
        }
    },
    actions: {
        login({commit, state}, userInfo) {
            return new Promise((resolve, reject) => {
                login(userInfo).then(res => {
                    if (res.code != 200) {
                        reject(res)
                    }
                    commit('SET_ACCESS_TOKEN', res.token)
                    commit('SET_REFRESH_TOKEN', res.refreshToken)
                    commit('SET_ACCESS_TOKEN_EXP', res.exp)
                    commit('SET_REFRESH_TOKEN_EXP', res.refreshExp)
                    resolve(res)
                }).catch(e => {
                    reject(e)
                })
            })
        },
        queryUser({commit}) {
            return new Promise((resolve, reject) => {
                getMe().then(res => {
                    if (res.code != 200) {
                        reject(res)
                    }
                    console.log(res)
                    if (res.data.perms == null || res.data.perms.length == 0) {
                        commit('SET_PERMISSIONS', ['no_permission'])
                    } else {
                        commit('SET_PERMISSIONS', res.data.perms)
                    }
                    commit('SET_USER_INFO', res.data)
                    resolve(res)
                }).catch(e => {
                    reject(e)
                })
            })
        },
        logout({commit, state}) {
            return new Promise((resolve) => {
                logout({RefreshToken: localStorage.getItem('refreshToken')}).finally(() => {
                    commit('SET_ACCESS_TOKEN', '')
                    commit('SET_REFRESH_TOKEN', '')
                    commit('SET_ACCESS_TOKEN_EXP', '')
                    commit('SET_REFRESH_TOKEN_EXP', '')

                    commit('SET_PERMISSIONS', [])
                    commit('SET_MENU_TREE', [])

                    commit('SET_USER_INFO', {})

                    commit('DEL_ALL_TAG')

                    localStorage.removeItem('accessToken')
                    localStorage.removeItem('refreshToken')
                    localStorage.removeItem('accessTokenExp')
                    localStorage.removeItem('refreshTokenExp')

                    localStorage.removeItem('permissions')
                    localStorage.removeItem('menuTrees')

                    localStorage.removeItem('userInfo')
                    resolve()
                })
            })
        },
        refreshToken({commit}, res) {
            commit('SET_ACCESS_TOKEN', res.data.token)
            commit('SET_REFRESH_TOKEN', res.data.refreshToken)
            commit('SET_ACCESS_TOKEN_EXP', res.data.exp)
            commit('SET_REFRESH_TOKEN_EXP', res.data.refreshExp)
        },
        initData({commit}) {


        }
    }
}

export default user
